import React from "react";
// import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import logo1 from "../Images/logo1.png";
import bgauth from "../Images/bg-auth.jpg";

const Otp = () => {
  const navigate = useNavigate();

  const handleOtpVerification = () => {
    navigate("/reset-password");
  };
  return (
    <div
      className="flex justify-center items-center min-h-screen"
      style={{
        backgroundImage: `url(${bgauth})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="rounded-lg p-8 shadow-md w-full sm:max-w-lg backdrop-blur bg-green-50/50">
        <img src={logo1} alt="image1" className="mb-4 " />
        <form className="space-y-4">
          <div>
            <label className="block mb-4 font-semibold text-[#64748B] ">
              Enter 6 Digit OTP
            </label>
            <div className="flex space-x-2 justify-center ">
              <input
                type="text"
                maxLength="1"
                className="border border-gray-300 rounded px-3 py-2 text-center w-12"
                required
              />
              <input
                type="text"
                maxLength="1"
                className="border border-gray-300 rounded px-3 py-2 text-center w-12"
                required
              />
              <input
                type="text"
                maxLength="1"
                className="border border-gray-300 rounded px-3 py-2 text-center w-12"
                required
              />
              <input
                type="text"
                maxLength="1"
                className="border border-gray-300 rounded px-3 py-2 text-center w-12"
                required
              />
              <input
                type="text"
                maxLength="1"
                className="border border-gray-300 rounded px-3 py-2 text-center w-12"
                required
              />
              <input
                type="text"
                maxLength="1"
                className="border border-gray-300 rounded px-3 py-2 text-center w-12"
                required
              />
            </div>
          </div>

          <div className="flex justify-center text-[#64748B]">
            <button
              type="submit"
              onClick={handleOtpVerification}
              className="mt-2 bg-slate-500 text-white px-5 py-2 rounded-md shadow-md hover:text-black hover:bg-transparent hover:border-slate-500 border-2 border-solid transition-all duration-300"
            >
              Verify OTP
            </button>
          </div>
        </form>
        <p className="text-center text-lg text-[#64748B] pt-3 font-semibold">
          Didn't Recive OTP?
          <Link className="text-blue-300 pl-1" to="/signup">
            {" "}
            Email Verification
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Otp;
